import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Layout } from './components/Layout'
import { PrivateRoute } from './router/PrivateRoute'
import { LoginPage } from './views/Login'
import { Submitted } from './views/Submitted'
import { Survey } from './views/Survey'

function App() {
  return (
    <Switch>
      <Route path="/login">
        <Layout centered={true}>
          <LoginPage />
        </Layout>
      </Route>
      <PrivateRoute path="/response">
        <Layout>
          <Survey />
        </Layout>
      </PrivateRoute>
      <PrivateRoute path="/submitted">
        <Layout>
          <Submitted />
        </Layout>
      </PrivateRoute>
      <PrivateRoute path="/">
        <Layout>
          <Survey />
        </Layout>
      </PrivateRoute>
      {/*<Route path="/">*/}
      {/*  {asyncSession.loading && <div>Loading</div>}*/}
      {/*  {asyncSession.result?.isLoggedIn ? (*/}
      {/*    <Layout centered={false}>*/}
      {/*      <Survey />*/}
      {/*    </Layout>*/}
      {/*  ) : (*/}
      {/*    <Layout centered={true}>*/}
      {/*      <LoginPage />*/}
      {/*    </Layout>*/}
      {/*  )}*/}
      {/*</Route>*/}
    </Switch>
  )
}

export default App
